<template>
  <div class="wlx-site-manager-wrapper wlx-user-manager">
    <header class="site-manager-head-con" style="padding-top: 20px">
      <el-form :inline="true" size="small">
        <el-form-item>
          <el-input
            v-model="stuName"
            placeholder="请输入学生名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="schoolName"
            placeholder="请输入学校名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="idCard"
            placeholder="请输入身份证号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="certificateNum"
            placeholder="请输入证书编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="examinationTypeId"
            clearable
            filterable
            placeholder="请选择考核类型"
            @change="typeChnage"
          >
            <el-option
              v-for="item in searchCertTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="examinationGradeId"
            clearable
            filterable
            placeholder="请选择考核等级"
          >
            <el-option
              v-for="item in searCertGradeList"
              :key="item.value"
              :label="item.lable"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="provinceName" clearable filterable placeholder="请选择省份">
            <el-option
              v-for="item in provinceList"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
          <el-select v-model="cityName" clearable placeholder="请选择城市">
            <el-option
              v-for="item in cityList"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getStudentResultInfo()"
            >搜索</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="addInfo"
            >新增</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="ImportDialogVisible = true"
            >导入</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-delete"
            @click="multiDeleteCertificate"
            >删除</el-button
          >
          <el-button
            class="stu-add-button"
            type="primary"
            size="medium"
            @click="openTXtDialog()"
            >头像上传</el-button
          >

          <el-button
            class="stu-add-button"
            type="primary"
            size="medium"
            @click="multiCreateCertificate()"
            >生成证书</el-button
          >
          <el-button
            class="stu-add-button"
            type="primary"
            size="medium"
            @click="exportCertificateZip"
            >批量导出证书</el-button
          >

          <a
            class="export-button-a"
            style="color: #fff; margin-left: 10px"
            :href="exportExam"
            >导出</a
          >
        </el-form-item>
      </el-form>
    </header>

    <el-table
      class="certificate-manager-table"
      :data="list"
      height="calc(100vh - 300px)"
      border
      stripe
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        prop="id"
        type="selection"
        width="50"
        fixed="left"
      ></el-table-column>
      <el-table-column
        label="序号"
        type="index"
        width="60"
        fixed="left"
      ></el-table-column>
      <el-table-column
        prop="studentName"
        label="学生姓名"
        width="110"
        fixed="left"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="idCard"
        label="身份证号"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="certificateType"
        label="项目(证书类型)"
        min-width="300"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="schoolName"
        label="所在单位"
        min-width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="certificateNum"
        label="证书编号"
        width="170"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="peixunName"
        label="参训名称"
        min-width="240"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="peixunTime"
        label="参训时间"
        width="170"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="examinationGrade"
        label="级别"
        width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="awardingUnit"
        label="颁证单位"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dateofIssue"
        label="颁证时间"
        width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="effectiveTime"
        label="有效期(年)"
        width="100"
      ></el-table-column>
      <el-table-column prop="certificateUrl" label="电子证书" width="100">
        <template slot-scope="scope">
          <img
            v-if="scope.row.certificateUrl"
            style="height: 60px"
            :src="scope.row.certificateUrl"
            @click="clickImg(scope.row.certificateUrl)"
          />
          <span v-else>未生成</span>
        </template>
      </el-table-column>
      <el-table-column prop="effectiveTime" label="照片" width="80">
        <template slot-scope="scope">
          <img
            :src="scope.row.studentUrl"
            height="50"
            width="50"
            v-if="scope.row.studentUrl"
          />
          <img
            src="/static/img/default_avatar3.24690a70.png"
            height="50"
            width="50"
            v-else
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="dateCreated"
        label="创建日期"
        width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="340" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="primary"
            @click="handleCreatedCertificate(scope.row.id)"
            >生成证书</el-button
          >
          <el-button
            v-if="scope.row.certificateUrl"
            size="mini"
            type="success"
            @click="exportCertificate(scope.row)"
            >导出证书</el-button
          >
          <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="u-page-con">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="onPageChangeHandler"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        v-show="totalCount > 0"
        style="text-align: center"
      ></el-pagination>
    </div>

    <el-dialog
      :title="titleFormVisible"
      :modal="false"
      :visible.sync="dialogFormVisible"
      width="800px"
    >
      <!-- :modal="false" -->
      <el-form
        :inline="true"
        :model="from"
        class="demo-form-inline"
        label-width="120px"
      >
        <el-form-item label="学生姓名">
          <el-input v-model="from.studentName"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="from.idCard"></el-input>
        </el-form-item>
        <el-form-item label="参训名称">
          <el-input v-model="from.peixunName"></el-input>
        </el-form-item>
        <el-form-item label="参训时间">
          <el-input v-model="from.peixunTime"></el-input>
        </el-form-item>
        <el-form-item label="所在单位">
          <el-input v-model="from.schoolName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="考核时间">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="from.examTime"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item label="证书编号">
          <el-input v-model="from.certificateNum"></el-input>
        </el-form-item>
        <el-form-item label="颁证时间">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="from.dateofIssue"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="项目(证书类型)">
          <el-select
            v-model="from.examinationTypeId"
            placeholder="请选择"
            @change="typeChnage"
          >
            <el-option
              v-for="item in certTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证书等级">
          <el-select v-model="from.examinationGradeId" placeholder="请选择">
            <el-option
              v-for="item in certGradeList"
              :key="item.value"
              :label="item.lable"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="颁证单位">
          <el-input v-model="from.awardingUnit"></el-input>
        </el-form-item>
        <el-form-item label="有效期(X年)">
          <el-input v-model="from.effectiveTime"></el-input>
        </el-form-item>

        <!-- <el-form-item label="考核站点">
          <el-input v-model="from.siteName"></el-input>
        </el-form-item>
        <el-form-item v-show="from.examYMEnglish!= ''" label="考核年月英文">
          <el-input disabled v-model="from.examYMEnglish"></el-input>
        </el-form-item>
        <el-form-item v-show="from.examinationGradeEnglish!= ''" label="考核等级英文">
          <el-input disabled v-model="from.examinationGradeEnglish"></el-input>
        </el-form-item>-->
        <el-form-item  label="学生名称拼音">
          <el-input v-model="from.studentNamePinyin"></el-input>
        </el-form-item>
        <el-form-item  label="学时">
          <el-input v-model="from.classHour"></el-input>
        </el-form-item>
        <el-form-item label="学生头像">
          <imageUpload
            class="img_upload"
            :url="urlAliyunOSS"
            :files.sync="from.studentUrl"
            v-if="dialogFormVisible"
            format="image"
          ></imageUpload>
        </el-form-item>
         <el-form-item label="证书">
          <imageUpload
            class="img_upload"
            :url="urlAliyunOSS"
            :files.sync="from.certificateUrl"
            v-if="dialogFormVisible"
            format="image"
          ></imageUpload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelInfo">取 消</el-button>
        <el-button type="primary" @click="editInfo()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :before-close="cancel"
      title="Excel导入"
      :visible.sync="ImportDialogVisible"
      width="50%"
      top="3%"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="form"
        label-width="80px"
        size="mini"
        @submit.prevent="importFile"
      >
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="uploadUrl"
          :file-list="fileList"
          :auto-upload="false"
          :on-success="onSuccess"
          accept="xls, xlsx"
          :limit="1"
          style="display: inline-block; text-align: center; margin-top: 15px"
        >
          <el-button slot="trigger" type="primary">选取文件</el-button>
          <a
            style="
              color: #049cdb;
              text-decoration: underline;
              margin-left: 15px;
            "
            href="/public/docs/师资证书信息导入模板.xlsx"
            >下载模板</a
          >
          <div slot="tip" class="el-upload__tip"></div>
        </el-upload>
        <p class="excelparaph" style="font-size: 18px; margin: 0px 0px 10px">
          注意事项：
        </p>
        <ul class="attention_excel" style="font-size: 16px; padding-left: 40px">
          <li>1.请按照模板规范顺序导入数据,确认表格数据是否填写完整</li>
        </ul>
        <el-table
          :data="errorList"
          v-show="errorList.length > 0"
          style="width: 100%"
        >
          <el-table-column
            prop="stuName"
            label="行号"
            width="180"
          ></el-table-column>
          <el-table-column
            prop="errorMsg"
            label="错误"
            style="width: 80%"
          ></el-table-column>
        </el-table>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="importFile()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 数据导入结果 -->
    <el-dialog
      title="数据导入结果"
      :visible.sync="dataResultVisible"
      width="740px"
      class="import-stu-info-dialog"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="tip-info-main">
        <div class="import-table-con">
          <p>
            <i class="kz-icon-tishi"></i> 您本次共导入{{
              count
            }}条数据，导入结果如下
          </p>
          <div>
            <div class="clearfix down-load-btn">
              <span class="fl sp-import-num">导入成功：{{ successNum }}条</span>
              <a v-if="successNum > 0" :href="successUploadFileUrl">
                <el-button type="primary" class="fr"
                  >下载导入成功记录</el-button
                >
              </a>
            </div>
            <div class="clearfix down-load-btn">
              <span class="fl sp-import-num">导入失败：{{ failNum }}条</span>
              <a v-if="failNum > 0" :href="failUploadFileUrl">
                <el-button type="primary" class="fr download-model-btn"
                  >下载导入失败记录</el-button
                >
              </a>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dataResultVisible = false">取 消</el-button>
        <el-button type="primary" @click="dataResultVisible = false"
          >关 闭</el-button
        >
      </span>
    </el-dialog>
    <!-- 批量删除 -->
    <el-dialog
      :before-close="cancel"
      title="批量删除"
      :visible.sync="DeleteAllDialogVisible"
      width="30%"
      top="3%"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" label-width="120px" size="mini">
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="deleteStartTime"
            type="datetime"
            placeholder="选择开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="deleteEndTime"
            type="datetime"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDeleteAll">取 消</el-button>
        <el-button type="primary" @click="deleteAll()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="考生头像上传"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="touXiangDialog"
      :show-close="false"
      class="change-dialog-head-wrapper"
      width="50%"
    >
      <div style="position: relative; line-height: 36px">
        <el-form label-width="100px" size="small">
          <el-form-item label="证书类型">
            <el-select
              v-model="uploadCertificateTypeIds"
              multiple
              collapse-tags
              filterable
              clearable
              placeholder="请选择要更新照片的证书类型"
              style="width: 100%"
            >
              <el-option
                v-for="item in certTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <p style="font-size: 20px">注意事项:</p>
        <p style="color: red; font-size: 20px; margin-left: 50px">
          1、照片的命名规则为身份证号.图片格式，如 341222200109179410.jpg
        </p>
        <p style="color: red; font-size: 16px; margin-left: 50px">
          2、仅更新上方选中证书类型中的照片数据
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <stuActivtyUpload
          style="margin-right: 10px"
          :url="urlAliyunOSS"
          :ispartner="0"
          :disabled="uploadCertificateTypeIds.length === 0"
          :files="files"
          @done="onAllFilesUpload"
        ></stuActivtyUpload>
        <el-button type="primary" @click="closeTXtDialog"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="未匹配名单"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="TisiDialog"
      :show-close="false"
      class="change-dialog-head-wrapper"
      width="50%"
    >
      <div
        style="
          position: relative;
          line-height: 36px;
          height: 500px;
          overflow: scroll;
        "
      >
        <p
          style="color: red; font-size: 20px; margin-left: 50px"
          v-for="(item, index) in tisiList"
          :key="index"
        >
          {{ index + 1 }}、{{ item }}
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="TisiDialog = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="在线证书展示"
      :modal="false"
      top="10px"
      :visible.sync="imageUrlShow"
      width="1280px"
    >
      <div>
        <img :src="imageUrl" style="width: 1200px; height: 850px" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="imageUrlClose">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
import stuActivtyUpload from "components/stuActivtyUpload.vue";
export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      totalCount: 0,
      stuName: "",
      schoolName: "",
      idCard: "",
      certificateNum: "",
      examinationTypeId: "",
      examinationGradeId: "",
      list: [],
      from: {
        id: "",
        studentName: "",
        examName: "",
        examTime: "",
        examinationTypeId: "",
        examinationType: "",
        examinationGradeId: "",
        examinationGrade: "",
        siteName: "",
        idCard: "",
        qualifiedState: "合格",
        certificateNum: "",
        dateofIssue: "",
        examYMEnglish: "",
        examinationGradeEnglish: "",
        studentNamePinyin: "",
        studentUrl: "",
        certificateUrl:"",
        classHour:"",
        //
        schoolName: "",
        peixunName: "",
        peixunTime: "",
        awardingUnit: "",
        effectiveTime: "",
      },
      files: [],
      urlAliyunOSS: "/api/design/osssign/getsign",
      //编辑信息
      titleFormVisible: "",
      dialogFormVisible: false,
      //导入
      ImportDialogVisible: false,
      uploadUrl: "/api/XOrg/CertificateManager/uploadExcelTea",
      fileList: [], //导入文件
      errorList: [], //错误信息
      certTypeList: [],
      certGradeList: [],
      certTypeId: "",
      searchCertTypeList: [],
      searCertGradeList: [],
      // 导入结果
      dataResultVisible: false,
      count: 0,
      successNum: 0,
      successFileName: "",
      failNum: 0,
      failFileName: "",
      // 批量删除
      DeleteAllDialogVisible: false,
      deleteStartTime: "",
      deleteEndTime: "",
      // 头像上传
      touXiangDialog: false,
      uploadCertificateTypeIds: [],
      TisiDialog: false,
      tisiList: [],
      //省市
      provinceList: [],
      provinceName: "",
      cityList: [],
      cityName: "",
      imageUrl: "",
      imageUrlShow: false,
      ids: [],
      selectedRows: [],
    };
  },
  components: {
    imageUpload,
    stuActivtyUpload,
  },
  computed: {
    failUploadFileUrl() {
      return decodeURI(
        "/api/XOrg/ResultsManager/uploadFile?fileName=" + this.failFileName
      );
    },
    successUploadFileUrl() {
      return decodeURI(
        "/api/XOrg/ResultsManager/uploadFile?fileName=" + this.successFileName
      );
    },
    exportExam: function () {
      return (
        "/api/XOrg/CertificateManager/exportExamExcel?studentName=" +
        this.stuName +
        "&schoolName=" +
        this.schoolName +
        "&idCard=" +
        this.idCard +
        "&ExaminationGradeId=" +
        this.examinationGradeId +
        "&CertificateTypeId=" +
        this.examinationTypeId +
        "&certificateNum=" +
        this.certificateNum +
        "&type=1" +
        "&province=" +
        this.provinceName
      );
    },
    exportCertificateZipUrl() {
      return (
        "/api/XOrg/CertificateManager/exportCertificateZip?ids=" +
        encodeURIComponent(
          this.selectedRows
            .filter((item) => item.certificateUrl)
            .map((item) => item.id)
            .join(",")
        )
      );
    },
  },
  created() {
    this.getStudentResultInfo();
    this.getCertificateType();
    this.getSearchCertificateType();
    this.getProvinceList();
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    "from.examinationTypeId": function (val) {
      this.getCertificateGrade();
    },
    // eslint-disable-next-line no-unused-vars
    examinationTypeId: function (val) {
      this.getSearchCertificateGrade();
    },
  },
  methods: {
    clickImg(url) {
      this.imageUrl = url;
      this.imageUrlShow = true;
    },

    imageUrlClose() {
      this.imageUrlShow = false;
    },

    exportCertificate(row) {
      if (!row.certificateUrl) {
        this.$message.warning("该记录还没有生成证书");
        return;
      }
      window.location.href =
        "/api/XOrg/CertificateManager/exportCertificate?id=" +
        encodeURIComponent(row.id);
    },

    exportCertificateZip() {
      if (this.ids.length === 0) {
        this.$message.warning("请先勾选需要导出的证书");
        return;
      }
      if (!this.selectedRows.some((item) => item.certificateUrl)) {
        this.$message.warning("勾选的记录还没有生成证书");
        return;
      }
      window.location.href = this.exportCertificateZipUrl;
    },

    handleSelectionChange(val) {
      this.selectedRows = val;
      this.ids = [];
      val.forEach((element) => {
        this.ids.push(element.id);
      });
    },

    // 获取省
    getProvinceList() {
      this.$http.post("/api/XOrg/District/getProvinceList").then((res) => {
        if (res.code > 0) {
          this.provinceList = res.province;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    // 获取市
    getCityListByName() {
      this.$http
        .post("/api/XOrg/District/getCityListByName", {
          province: this.provinceName,
        })
        .then((res) => {
          if (res.code > 0) {
            this.cityList = res.cityList;
          } else {
            this.$message.warning(res.msg);
          }
        });
    },

    //上传头像弹窗
    openTXtDialog() {
      this.touXiangDialog = true;
    },
    closeTXtDialog() {
      this.touXiangDialog = false;
      this.uploadCertificateTypeIds = [];
    },
    //学生头像上传
    onAllFilesUpload(file) {
      if (this.uploadCertificateTypeIds.length === 0) {
        this.$message.warning("请先选择要更新照片的证书类型");
        return;
      }
      this.$http
        .post("/api/XOrg/CertificateManager/saveCertificateFile", {
          fileList: JSON.stringify(file),
          certificateTypeIds: this.uploadCertificateTypeIds,
        })
        .then((res) => {
          if (res.code > 0) {
            if (res.list.length == 0) {
              this.$message.success(res.msg);
              this.closeTXtDialog();
            } else {
              this.TisiDialog = true;
              this.tisiList = res.list;
            }
            this.getStudentResultInfo();
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    deleteAll() {
      var that = this;
      this.$confirm("此操作将删除该时间段证书数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$http
          .post("/api/XOrg/CertificateManager/deleteCertificateAll", {
            startTime: this.deleteStartTime,
            endTime: this.deleteEndTime,
          })
          .then(function (rst) {
            if (rst.code > 0) {
              that.$message.success(rst.msg);
              that.DeleteAllDialogVisible = false;
              that.getStudentResultInfo();
            } else {
              that.$message.warning(rst.msg);
            }
          });
      });
    },
    cancelDeleteAll() {
      this.DeleteAllDialogVisible = false;
      this.deleteStartTime = "";
      this.deleteEndTime = "";
    },
    getSearchCertificateType() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertificateTypeManager/getCertificateType", {
          type: 1,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.searchCertTypeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getSearchCertificateGrade() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
          typeId: this.examinationTypeId,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.searCertGradeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getCertificateType() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertificateTypeManager/getCertificateType", {
          type: 1,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.certTypeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    typeChnage() {
      // this.getCertificateGrade();
      this.from.examinationGradeId = "";
    },
    getCertificateGrade() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
          typeId: this.from.examinationTypeId,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.certGradeList = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    cancelInfo() {
      this.from.id = "";
      this.from.studentName = "";
      this.from.examName = "";
      this.from.examTime = "";
      this.from.examinationTypeId = "";
      this.from.examinationType = "";
      this.from.examinationGradeId = "";
      this.from.examinationGrade = "";
      this.from.siteName = "";
      this.from.idCard = "";
      this.from.qualifiedState = "";
      this.from.certificateNum = "";
      this.from.dateofIssue = "";
      this.from.examYMEnglish = "";
      this.from.examinationGradeEnglish = "";
      this.from.studentNamePinyin = "";
      this.from.studentUrl = "";
      this.from.certificateUrl = "";
      this.from.classHour ="";
      //
      this.from.schoolName = "";
      this.from.peixunName = "";
      this.from.peixunTime = "";
      this.from.awardingUnit = "";
      this.from.effectiveTime = "";
      this.dialogFormVisible = false;
    },
    onSuccess(res) {
      if (res.code > 0) {
        this.ImportDialogVisible = false;
        this.fileList = [];
        this.dataResultVisible = true;
        this.count = res.info.count;
        this.successNum = res.info.successNum;
        this.successFileName = res.info.successFileName;
        this.failNum = res.info.failNum;
        this.failFileName = res.info.failFileName;
        this.getStudentResultInfo();
      } else {
        this.fileList = [];
        this.$message.warning(res.msg);
      }
      // if (res.code < 0) {
      //   if (res.code === -5) {
      //     this.errorList = res.list;
      //   } else {
      //     this.$message.warning(res.msg);
      //   }
      // } else {
      //   this.ImportDialogVisible = false;
      //   this.$message.success("导入成功");
      //   this.fileList = [];
      //   this.getStudentResultInfo();
      // }
    },
    //导入题库
    importFile() {
      this.$refs.upload.submit();
    },
    //清除数据
    cancel() {
      this.ImportDialogVisible = false;
      this.fileList = [];
    },
    addInfo() {
      this.titleFormVisible = "新增";
      this.dialogFormVisible = true;
    },
    //编辑
    editInfo() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertificateManager/addOrEditCertificate", {
          id: this.from.id,
          studentName: this.from.studentName,
          studentNamePinyin: this.from.studentNamePinyin,
          examName: this.from.examName,
          examTime: this.from.examTime,
          examinationGradeId: this.from.examinationGradeId,
          examinationTypeId: this.from.examinationTypeId,
          siteName: this.from.siteName,
          idCard: this.from.idCard,
          qualifiedState: this.from.qualifiedState,
          certificateNum: this.from.certificateNum,
          dateofIssue: this.from.dateofIssue,
          studentUrl: this.from.studentUrl,
          certificateUrl : this.from.certificateUrl,
          classHour: this.from.classHour,
          //
          schoolName: this.from.schoolName,
          peixunName: this.from.peixunName,
          peixunTime: this.from.peixunTime,
          awardingUnit: this.from.awardingUnit,
          effectiveTime: this.from.effectiveTime,
          type: 1,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.cancelInfo();
            that.getStudentResultInfo();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    //弹出框赋值
    handleEdit(row) {
      this.from.id = row.id;
      this.from.studentName = row.studentName;
      this.from.examName = row.examName;
      this.from.examTime = row.examTime;
      this.from.examinationGradeId = row.examinationGradeId;
      this.from.examinationTypeId = row.certificateTypeId;
      this.from.siteName = row.siteName;
      this.from.idCard = row.idCard;
      this.from.qualifiedState = row.qualifiedState;
      this.from.certificateNum = row.certificateNum;
      this.from.dateofIssue = row.dateofIssueData;
      this.from.examYMEnglish = row.examYMEnglish;
      this.from.examinationGradeEnglish = row.examinationGradeEnglish;
      this.from.studentNamePinyin = row.studentNamePinyin;
      this.from.studentUrl = row.studentUrl;
      this.from.certificateUrl = row.certificateUrl;
      this.from.classHour = row.classHour;
      //
      this.from.schoolName = row.schoolName;
      this.from.peixunName = row.peixunName;
      this.from.peixunTime = row.peixunTime;
      this.from.awardingUnit = row.awardingUnit;
      this.from.effectiveTime = row.effectiveTime;
      this.titleFormVisible = "编辑";
      this.dialogFormVisible = true;
    },

   multiCreateCertificate(){
     this.handleCreatedCertificate(this.ids);
   },

    handleCreatedCertificate(id) {
      var that = this;
      this.$confirm("此操作将重新生成该证书数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$http
          .post("/api/XOrg/CertificateManager/createdCertificate", {
            ids: id,
          })
          .then(function (rst) {
            if (rst.code > 0) {
              that.$message.success(rst.msg);
              that.getStudentResultInfo();
            } else {
              that.$message.warning(rst.msg);
            }
          });
      });
    },
    multiDeleteCertificate()
        {
            var that = this;
            var ids=this.ids;
            if(ids.length==0){
                that.$message.warning("请选择要删除的证书数据");

                return;
            }

            this.$confirm("此操作将删除"+ids.length+"条证书数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                .post("/api/XOrg/CertificateManager/deleteCertificateInfo", {
                    ids: ids,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                    that.$message.success(rst.msg);
                    that.getStudentResultInfo();
                    } else {
                    that.$message.warning(rst.msg);
                    }
                });
            });
        },
    //删除
    deleteInfo(id) {
      var that = this;
      this.$confirm("此操作将删除该证书数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.$http
          .post("/api/XOrg/CertificateManager/deleteCertificateInfo", {
            ids: id,
          })
          .then(function (rst) {
            if (rst.code > 0) {
              that.$message.success(rst.msg);
              that.getStudentResultInfo();
            } else {
              that.$message.warning(rst.msg);
            }
          });
      });
    },
    //查询
    getStudentResultInfo() {
      var that = this;
      this.$http
        .post("/api/XOrg/CertificateManager/getCertificateList", {
          studentName: this.stuName,
          schoolName: this.schoolName,
          idCard: this.idCard,
          ExaminationGradeId: this.examinationGradeId,
          CertificateTypeId: this.examinationTypeId,
          certificateNum: this.certificateNum,
          type: 1,
          province: that.provinceName,
          city: that.cityName,
          PageSize: that.pageSize,
          page: that.page,
        })
        .then(function (rst) {
          if (rst.code > 0) {
            that.list = rst.list;
            that.page = rst.pagination.pageIndex;
            that.pageSize = rst.pagination.pageSize;
            that.totalCount = rst.pagination.totalCount;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getStudentResultInfo();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getStudentResultInfo();
    },
  },
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
  .certificate-manager-table {
    width: 100%;
    margin-top: 8px;
  }

  .u-page-con {
    margin-top: 12px;
  }

  .export-button-a {
    padding: 9px 15px;
    background-color: #409eff;
    font-size: 12px;
    border-radius: 3px;
  }

  .demo-form-inline {
    .el-input__inner {
      width: 200px;
    }
    .img_upload {
      width: 500px;
    }
  }
}
.import-stu-info-dialog {
  .el-dialog__header {
    background: #2f7dff;

    .el-dialog__title {
      color: #fff;
    }

    .el-dialog__headerbtn,
    .el-icon-close {
      color: #fff;
    }
  }

  .tip-info-main {
    margin: 20px 30px;
    color: #1a2638;
  }

  .top-tip-con {
    padding-bottom: 25px;
    border-bottom: 1px solid #d8e0e6;
  }

  .tip-article-con {
    margin-left: 10px;
    width: 550px;
    line-height: 1.5;

    .mark-tip {
      color: #e65b72;
    }
  }

  .download-model-con {
    margin-top: 29px;
    text-align: center;
  }

  .download-model-btn {
    background: #ee6c3a;
    border-color: #ee6c3a;
  }

  .import-table-con {
    padding-top: 20px;
    text-align: center;
  }

  .down-load-btn {
    margin-top: 25px;
  }

  .sp-import-num {
    margin-top: 6px;
  }

  .select-impoort-file {
    margin-top: 20px;
  }
}
</style>
